module.exports = __webpack_public_path__ + "img/large-corporate-customer-agreement.391cf5c7.svg";